/**
 * UUID hry musí být stabilní napříč restarty (viz CLAUDE.md). Původní web ho
 * skládal z Math.random(); crypto.randomUUID je k dispozici ve všech cílových
 * prohlížečích a nekoliduje. Fallback zůstává pro nezabezpečený kontext (http).
 */
export function generateGameUuid(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
